module.exports = __webpack_public_path__ + "static/media/Levi_napkin_blush.edd94b7b.jpg";